import { useEffect, useState } from "react";

export function useIsOptanonReady() {
  const [isOptanonReady, setIsOptanonReady] = useState(false);

  useEffect(() => {
    if (__DEV__) {
      setIsOptanonReady(true);
      return;
    }

    // Timeout to avoid waiting indefinitely
    const timeoutId = setTimeout(() => {
      console.log("Optanon check timed out after 5 seconds. Rendering app.");
      setIsOptanonReady(true);
    }, 5000);

    // Check every 100ms if Optanon is ready
    const intervalId = setInterval(() => {
      if (
        typeof window !== "undefined" &&
        window.Optanon &&
        typeof window.Optanon.Init === "function"
      ) {
        console.log("Optanon is ready. Rendering app.");
        setIsOptanonReady(true);

        clearInterval(intervalId);
        clearTimeout(timeoutId);
      }
    }, 100);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  return isOptanonReady;
}
